"use client";

import dynamic from "next/dynamic";
import { NewArrivalsCarouselSkeleton } from "./NewArrivalsCarouselSkeleton";

export const HomeProductCarouselLazy = dynamic(
  () => import("./HomeProductCarousel").then((module) => module.HomeProductCarousel),
  { ssr: false, loading: () => <NewArrivalsCarouselSkeleton /> },
);
